import type { OAuthTokenResponse, OAuthTokens } from './tokens';
import { mapTokenResponse } from './tokens.ts';

const TOKEN_ENDPOINT = '/api/refresh';
const EXCHANGE_ENDPOINT = '/api/auth/exchange';

const isDevRefreshFromStorage =
  process.env.NODE_ENV === 'development' || process.env.REACT_APP_USE_TOKEN_AUTH === 'true';

export const postRefreshToken = async (refreshToken: string): Promise<OAuthTokens> => {
  // Dynamic import avoids circular dependency: axios.js → refreshFlow → this module.
  const { default: axiosInstance } = await import('../axios.js');
  // Production/QA: refresh from httpOnly cookie; body may be empty.
  // When REACT_APP_NODE_ENV=development, send refresh_token from localStorage for local/dev backends.
  const bodyRefreshToken =
    isDevRefreshFromStorage && typeof window !== 'undefined'
      ? window.localStorage.getItem('refresh_token') ?? refreshToken
      : refreshToken;

  const { data } = await axiosInstance.post<OAuthTokenResponse>(
    TOKEN_ENDPOINT,
    { refresh_token: bodyRefreshToken },
  );
  return mapTokenResponse(data);
};

export type AuthExchangeRequest = {
  handoff_token: string;
  organization_id?: string;
  organization_slug?: string;
};

export type AuthExchangeResponse = {
  message: string;
  access_token?: string;
  refresh_token?: string;
  token_type?: string;
  organization_id?: string;
  organization_slug?: string;
  user?: Record<string, unknown>;
};

export const postAuthExchange = async (payload: AuthExchangeRequest): Promise<AuthExchangeResponse> => {
  const { default: axiosInstance } = await import('../axios.js');
  const { data } = await axiosInstance.post<AuthExchangeResponse>(EXCHANGE_ENDPOINT, payload);
  return data;
};

